import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AdBroadcastInternalService } from './api/adBroadcastInternal.service';
import { AdBroadcastSeedService } from './api/adBroadcastSeed.service';
import { AdBroadcastServiceMaintenanceService } from './api/adBroadcastServiceMaintenance.service';
import { BroadcastConnectionConfigurationService } from './api/broadcastConnectionConfiguration.service';
import { BroadcastConnectionConfigurationViewService } from './api/broadcastConnectionConfigurationView.service';
import { CaseBroadcastSettingsService } from './api/caseBroadcastSettings.service';
import { CaseBroadcastSettingsViewService } from './api/caseBroadcastSettingsView.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AdBroadcastInternalService,
    AdBroadcastSeedService,
    AdBroadcastServiceMaintenanceService,
    BroadcastConnectionConfigurationService,
    BroadcastConnectionConfigurationViewService,
    CaseBroadcastSettingsService,
    CaseBroadcastSettingsViewService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}